export enum AgencyRoleType {
    CAREGIVER = 'CAREGIVER',
    AGENCYADMIN = 'AGENCYADMIN',
    AGENCYNURSE = 'AGENCYNURSE',
    OWNER = 'OWNER',
    SEMBRANETADMIN = 'SEMBRANETADMIN',
    SEMBRANETNURSE = 'SEMBRANETNURSE',
    SEMBRANETOFFICE = 'SEMBRANETOFFICE',
    SUPPORT = 'SUPPORT',
    SPECIALTYSUPPORT = 'SPECIALTYSUPPORT',
    USER = 'USER',
    ADMIN = 'ADMIN',
  }
